import { Box } from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Column } from "components/common/Layout/Column";
import { Ride } from "types/Ride";
import { useEffect, useRef } from "react";

type Props = {
  ride: Ride;
};

const ActiveRideMap = ({ ride }: Props) => {
  const { origin, destination } = ride.driverOffer.travelOffer;
  const mapRef = useRef<any>(null);

  const fitToMarkers = (map: google.maps.Map) => {
    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend({ lat: origin.coordinates[1], lng: origin.coordinates[0] });
    bounds.extend({ lat: destination.coordinates[1], lng: destination.coordinates[0] });
    map.fitBounds(bounds);
    console.log("Map bounds set to fit markers");
  };

  useEffect(() => {
    if (mapRef.current) {
      fitToMarkers(mapRef.current);
    }
    console.log("ActiveRideMap component mounted or updated by origin/destination change");
  }, [origin, destination]);

  return (
    <Column sx={{ width: "100%", height: "100%" }}>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f0f0f0",
        }}
      >
        <GoogleMap
          zoom={15}
          mapContainerStyle={{ height: "100%", width: "100%" }}
          options={{
            disableDefaultUI: true,
            zoomControl: true,
            streetViewControl: false,
            mapTypeControl: false,
          }}
          onLoad={(map) => {
            mapRef.current = map;
            fitToMarkers(map);
          }}
        >
          <Marker
            position={{
              lat: origin.coordinates[1],
              lng: origin.coordinates[0],
            }}
            label={{
              text: "A",
              color: "white",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          />
          <Marker
            position={{
              lat: destination.coordinates[1],
              lng: destination.coordinates[0],
            }}
            label={{
              text: "B",
              color: "white",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          />
        </GoogleMap>
      </Box>
    </Column>
  );
};

export default ActiveRideMap;
